import React from 'react'
import { formatTemplateString } from 'helpers/formatter'
import styles from '../../common.module.scss'

export const SafeInfo = (props) => {
  const { lang, className = '' } = props

  const { securityGuideLink, guideLink } = lang?.profile || {}

  return (
    <div className={styles.safeInfo + ' ' + className}>
      <SafeIcon className={styles.safeInfo_icon} />
      <span
        dangerouslySetInnerHTML={{
          __html: formatTemplateString(securityGuideLink, {
            guideLink: `<a
              href="https://bossjob.crisp.help/en/article/bossjob-user-data-guide-19m0q4y/"
              target="_blank"
              >${formatTemplateString(guideLink, {})}</a>`
          })
        }}
      />
    </div>
  )
}

export default SafeInfo

const SafeIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M13.4038 2.79002L13.9981 2.79987C13.9981 2.79987 13.9991 4.37116 13.9997 5.65343C14.0002 6.91195 14 7.76559 13.9998 8.3737C13.9997 8.60271 13.9997 8.79689 13.9997 8.96476C13.9997 12.0603 10.0975 15.3333 7.99903 15.3333C5.90219 15.3333 2 12.0603 2 8.96476V2.79987L2.59588 2.79002C2.60876 2.79002 3.94063 2.76046 5.31436 2.19225C6.72353 1.60762 7.63345 0.937592 7.64151 0.931023L7.99742 0.666626L8.35656 0.931023C8.36461 0.939234 9.27292 1.60926 10.6837 2.19225C12.059 2.76046 13.3893 2.79002 13.4038 2.79002ZM7.88608 10.4633L11.6177 6.27937L10.6226 5.39189L7.37401 9.03428L5.57196 7.13L4.60352 8.04645L6.90433 10.4778C7.03259 10.6133 7.21179 10.6889 7.39839 10.6862C7.58498 10.6834 7.76187 10.6026 7.88608 10.4633Z'
      fill='url(#paint0_linear_6925_74320)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_6925_74320'
        x1='2'
        y1='7.99996'
        x2='14'
        y2='7.99996'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D6FCFF' />
        <stop offset='1' stopColor='#00D7E6' />
      </linearGradient>
    </defs>
  </svg>
)
